import React, { useEffect } from "react";

import {
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  Box,
  Stack,
} from "@mui/material";

import { TablePaginationActions } from "../pagination";

import { PreviewItem } from "./preview-item";

interface PreviewProps {
  column: Map<string, string>;
  rows: any[];
  error: boolean;
  isUseV2?: boolean;
  enableCache?: boolean;
  filteredCount?: number;
  totalCount?: number;
  onEnableCacheChange?: (enabled: boolean) => void;
}

export const Preview: React.FC<PreviewProps> = ({
  column,
  rows,
  error,
  isUseV2,
  enableCache,
  filteredCount = 0,
  totalCount = 0,
}) => {
  const [page, setPage] = React.useState(0);
  const [filteredRows, setFilteredRows] = React.useState<any>([]);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  useEffect(() => {
    const f = rows.filter((i: any) => i.errors);
    setFilteredRows(f);
  }, [rows]);

  const handleChangePage = (
    _event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const headerElement: JSX.Element[] = [];
  column.forEach((_, key: string, __) => {
    headerElement.push(<TableCell>{key}</TableCell>);
  });

  const rowElement: JSX.Element[] = [];
  filteredRows.forEach((row: any) => {
    rowElement.push(<PreviewItem item={row} column={column} />);
  });

  return (
    <Stack spacing={2}>
      {rowElement.length <= 0 && error ? (
        <Box
          sx={{
            width: "1300px",
            margin: 5,
            background: "#e09a9a",
            padding: 10,
          }}
        >
          <Typography align="center" variant="h5" sx={{ color: "white" }}>
            Something went wrong during the validation
          </Typography>
        </Box>
      ) : rowElement.length <= 0 ? (
        <Box
          sx={{
            width: "1300px",
            margin: 5,
            background: "#5cb85c",
            padding: 10,
          }}
        >
          <Typography align="center" variant="h5" sx={{ color: "white" }}>
            {" "}
            Validation Passed, Please Continue
          </Typography>
        </Box>
      ) : (
        <Table
          sx={{
            maxWidth: "1300px !important",
            display: "block",
            overflow: "auto",
          }}
        >
          <TableHead>
            <TableRow>{headerElement}</TableRow>
          </TableHead>
          <TableBody>
            {rowsPerPage > 0
              ? rowElement.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage,
                )
              : rowElement}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 200]}
                colSpan={Array.from(column.keys()).length}
                count={rowElement.length}
                rowsPerPage={rowsPerPage}
                page={page}
                sx={{
                  overflow: "hidden",
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        </Table>
      )}
    </Stack>
  );
};
